import React from 'react'
import PropTypes from 'prop-types'

const PlusCircleIcon2 = ({ size = '50', color = 'black', bgColor = 'white' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 54 54"
      fill="none">
      <path
        d="M27 52.1711C40.8071 52.1711 52 40.9782 52 27.1711C52 13.364 40.8071 2.17108 27 2.17108C13.1929 2.17108 2 13.364 2 27.1711C2 40.9782 13.1929 52.1711 27 52.1711Z"
        fill={bgColor}
        stroke={color}
        strokeWidth="3"
      />
      <path d="M37.0005 27.1711H17.0005" stroke={color} strokeWidth="3" strokeLinecap="round" />
      <path d="M27 37.1715L27 17.1715" stroke={color} strokeWidth="3" strokeLinecap="round" />
    </svg>
  )
}

export default React.memo(PlusCircleIcon2)

PlusCircleIcon2.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  bgColor: PropTypes.string,
}
